module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAdBAMAAABcXYHLAAAALVBMVEUAAABHcEwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADMHXDdAAAADnRSTlMRAIjuIrtEZt1VzKozdwrYXXoAAABsSURBVHheYxAUeAcCmxwFBWHsd08dwWxGQUER1Xc2MLag4IwXjHC2iJ0inC2o14hg5z1BsPmeIbFfIrHfIKk3RLD1AuFssXcT4ezi1zA3iGu9C0S401YQxn6lLiiIcCc+9jsYeIjMRlZDNTYAzuhZWG0qmSgAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/components/parts/catalog/card/components/block/images/rub.png
// module id = baba0374ce9763b0cda2
// module chunks = 0